
import { GearItem } from "@/types/gear";
import GearItemForm from "../GearItemForm";

interface GearFormDialogProps {
  onClose: () => void;
  onSubmit: (item: Partial<GearItem>) => void;
  initialData?: GearItem;
  showBudget: boolean;
  department: "camera" | "ge" | null;
  projectId: string;
}

export default function GearFormDialog({
  onClose,
  onSubmit,
  initialData,
  showBudget,
  department,
  projectId,
}: GearFormDialogProps) {
  return (
    <div className="fixed inset-0 bg-background/80 backdrop-blur-sm flex items-center justify-center p-2 md:p-4 z-50">
      <GearItemForm
        onClose={onClose}
        onSubmit={onSubmit}
        initialData={initialData}
        showBudget={showBudget}
        department={department}
        projectId={projectId}
      />
    </div>
  );
}
